import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/impostazioni/')({
  head: () => noIndexRouteHead('settings', 'it'),
  component: SettingsPage,
})
